import React from 'react';
import { v2 } from '@fieldnation/platform-components';
import {
  AdditionalPartField,
  AdditionalPartValues,
  FieldName,
  Section,
} from './types.d';
import styles from './styles.scss';
import { FIELD_ORDER } from './constants';

const { TextInput } = v2;

interface AdditionalPartFieldsProps {
  fields?: AdditionalPartField[];
  values?: AdditionalPartValues;
  section: Section;
  excludeFields?: FieldName[];
  onChange: (section: Section, fieldName: FieldName, value: string) => void;
  fieldClassName?: string;
}

const AdditionalPartFields = ({
  fields = [],
  values,
  section,
  excludeFields = [],
  onChange,
  fieldClassName = styles['item-spacing-md'],
}: AdditionalPartFieldsProps): JSX.Element | null => {
  const visibleFields = fields
    .filter((f) => f.required && !excludeFields.includes(f.field_name))
    .sort((a, b) => FIELD_ORDER.indexOf(a.field_name) - FIELD_ORDER.indexOf(b.field_name));

  if (visibleFields.length === 0) return null;

  return (
    <>
      {visibleFields.map((config) => (
        <div key={config.field_name} className={fieldClassName}>
          <TextInput
            label={config.field_label}
            value={values?.[section]?.[config.field_name] || ''}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
              onChange(section, config.field_name, e.target.value)
            }
          />
        </div>
      ))}
    </>
  );
};

AdditionalPartFields.defaultProps = {
  fields: [],
  values: undefined,
  excludeFields: [],
  fieldClassName: undefined,
};

export default AdditionalPartFields;
